import { methodDetailsActionTypes } from './Constants';

const initialState = {
	publisher_method: {
		books: {},
		publisher: {
			name: '',
		},
	},
	appliedFilters: {},
	loading: true,
	loadingFilter: true,
};

export default function methodReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data, firstLoad } = payload || {};

	switch (type) {
		case methodDetailsActionTypes.GET_METHOD_DETAILS_REQUEST:
			return {
				...state,
				loading: !firstLoad,
				loadingFilter: true,
			};
		case methodDetailsActionTypes.GET_METHOD_DETAILS_SUCCESS:
			return {
				...state,
				loading: false,
				loadingFilter: false,
				...data,
			};
		case methodDetailsActionTypes.GET_METHOD_DETAILS_ERROR:
			return {
				...state,
				loading: false,
				loadingFilter: false,
			};
		case methodDetailsActionTypes.CHANGE_METHOD_DETAILS_FILTERS:
			return {
				...state,
				...data,
			};
		case methodDetailsActionTypes.CLEAR_METHOD_DETAILS:
			return initialState;
		default:
			return state;
	}
}
